<template>
  <div class="optionSet container h-100">
    <div class="content">
      <div class="header mb8">
        <el-form :model="optionSet" class="form" :inline="true" label-width="80px" size="mini">
          <el-form-item label="">
            <el-select v-model="optionSet.field" filterable placeholder="请选择选项类型" @change="onSubmit" clearable>
              <el-option v-for="(item,key) in optionItems" :key="item" :label="optionItems[key]"
                         :value="key"></el-option>
            </el-select>
            <el-input v-model="optionSet.label" placeholder="显示值" clearable style="width: 200px;margin-left: 10px;"
                      @blur="onSubmit"/>
            <el-select v-model="optionSet.bool_radio" placeholder="是否单选" @change="onSubmit" clearable
                       style="margin-left: 10px;">
              <el-option v-for="(item,key) in MapBoolRadio" :key="key" :label="item.label" :value="key"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="el-button--operation" size="mini" @click="onSubmit">查询
            </el-button>
            <el-button @click="onReset" style="margin-right:0;" size="mini">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="addOption" icon="el-icon-plus" type="primary" size="mini">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleDelete" icon="el-icon-delete" type="danger" size="mini" :disabled="multiple">删除
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--      <el-row :gutter="15" class="mb8">-->
      <!--        <el-col :span="1.5">-->
      <!--          <el-button @click="addOption" icon="el-icon-plus" type="primary" size="mini">新增</el-button>-->
      <!--        </el-col>-->
      <!--        <el-col :span="1.5">-->
      <!--          <el-button @click="handleDelete" icon="el-icon-delete" type="danger" size="mini" :disabled="multiple">删除</el-button>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <div class="default-table">

        <el-table :data="optionData" @sort-change="sortChange" @selection-change="handleSelectionChange"
                  v-loading="loading" border>
          <el-table-column type="selection" width="55" align="center"/>
          <el-table-column label="序号" min-width="80" align="center">
            <template slot-scope="{$index}">{{ $index + 1 }}</template>
          </el-table-column>
          <el-table-column label="编号" prop="id" min-width="90" align="center"></el-table-column>
          <el-table-column label="选项类型" prop="field" min-width="140" align="center"
                           sortable="custom"></el-table-column>
          <el-table-column label="键名" prop="value" min-width="140" align="center"></el-table-column>
          <el-table-column label="键值（显示值）" prop="label" min-width="140" align="center"></el-table-column>
          <el-table-column label="是否单选" prop="uq_code" min-width="140" align="center">
            <template v-slot="{row:{bool_radio}}">
              <span v-if="MapBoolRadio[bool_radio]" :style="`color:${MapBoolRadio[bool_radio].color}`">
                {{ MapBoolRadio[bool_radio].label }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="统一代号" prop="uq_code" min-width="140" align="center"></el-table-column>
          <el-table-column label="创建时间" prop="created_at" min-width="140" align="center"
                           sortable="custom"></el-table-column>
          <el-table-column label="修改时间" prop="updated_at" min-width="140" align="center"
                           sortable="custom"></el-table-column>
          <el-table-column label="操作项" align="center" width="160" fixed="right">
            <template slot-scope="scope">
              <el-link type="primary" @click="editOption(scope.row)" v-if="userAuth.can_update_option"
                       icon="el-icon-edit">编辑
              </el-link>
              &nbsp;
              &nbsp;
              <el-link type="primary" @click="handleDelete(scope.row)" v-if="userAuth.can_delete_option"
                       icon="el-icon-delete">删除
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
            v-show="params.total>0"
            :total="params.total"
            :page.sync="params.page"
            :limit.sync="params.per_page"
            @pagination="search"
        />
      </div>
    </div>
    <el-dialog :title="`${type === 'add'?'新增':'编辑'}选项`" :visible.sync="dialogTableVisible">
      <el-form :model="optionForm" class="optionForm" label-width="80px" style="text-align:left;padding:40px 0;">
        <el-form-item label="选项类型" style="width:80%;margin:0 auto 20px">
          <el-select v-model="optionForm.field" filterable placeholder="请选择选项类型" class="optionSelect">
            <el-option v-for="(item,key) in optionItems" :key="item" :label="optionItems[key]" :value="key"/>
          </el-select>
        </el-form-item>
        <el-form-item label="键名" style="width:80%;margin:0 auto 20px">
          <el-input v-model="optionForm.value" placeholder="请输入标识" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="键值" style="width:80%;margin:0 auto 20px">
          <el-input v-model="optionForm.label" placeholder="请输入选项值" maxlength="32" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="统一代号" style="width:80%;margin:0 auto 20px">
          <el-input v-model="optionForm.uq_code" placeholder="请输入统一代号" maxlength="32" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="排序" style="width:80%;margin:0 auto 20px">
          <el-input v-model="optionForm.sort" placeholder="请输入排序值" oninput="if( value < 0 ){value = ''}"
                    onkeyup="value=value.replace(/[^\d]/g,'');"/>
        </el-form-item>
        <el-form-item label="是否单选" style="width:80%;margin:0 auto 40px">
          <el-switch v-model="optionForm.bool_radio" active-value="Y" inactive-value="N"/>
        </el-form-item>
        <div style="text-align:center;">
          <el-button type="primary" @click="newOption" style="margin-right:30px;">
            {{ type === 'add' ? '添加选项' : '保存' }}
          </el-button>
          <el-button type="info" @click="cancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>

import {getOptionList, addOrEditOption, deleteOption, getOptionDetail, getOptionItemList} from '@/api/option'

const MapBoolRadio = {
  Y: {label: '是', value: 'Y', color: 'darkred'},
  N: {label: '否', value: 'N', color: ''},
}
export default {
  name: 'optionSet',
  data() {
    return {
      MapBoolRadio,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      optionSet: {
        field: ''
      },
      params: {
        page: 1,
        per_page: 20,
        total: 0,
      },
      theadData: [],
      optionData: [],
      loading: false,
      dialogTableVisible: false,
      optionForm: {
        field: '',
        value: '',
        label: '',
        uq_code: '',
        sort: 0,
        bool_radio: 'N',
      },
      type: '',// add or edit
      id: '',// edit item's id
      optionItems: {},
      sort: {
        order: '',
        prop: ''
      }
    }
  },
  mounted() {
    this.getOptionItemList()
    this.getOptionList(this.params)
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    }
  },
  methods: {
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      let ids = row.id || this.ids;
      ids = Array.isArray(ids) ? ids : [ids];
      this.$msgbox.confirm('是否确认删除配置编号为"' + ids + '"的数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.banchDelete(ids)
        // return delRole(roleIds);
      }).then(() => {
        this.search();
        // this.msgSuccess("删除成功");
      }).catch(function () {
      });
    },
    onSubmit() {
      this.params.page = 1
      this.search()
    },
    onReset() {
      this.optionSet = {
        field: ''
      }
      this.params.page = 1
      this.search()
    },

    sortChange(e) {
      this.sort = {order: e.order, prop: e.prop}
      this.search()
    },
    search() {
      this.getOptionList({...this.optionSet, ...this.sort, ...this.params})
    },
    //选项列表
    getOptionList(data) {
      getOptionList(data).then(res => {
        this.theadData = res.model.tableCols
        this.optionData = res.model.data.data
        this.params.total = res.model.data.total
      })
    },
    //选项类型列表
    getOptionItemList() {
      this.loading = true
      getOptionItemList().then(res => {
        this.optionItems = res.model || []
        this.loading = false
      })
    },
    //添加选项
    addOption() {
      this.type = 'add'
      this.optionForm = {
        field: '',
        value: '',
        label: '',
        uq_code: '',
        sort: 0,
        bool_radio: 'N',
      }
      this.dialogTableVisible = true
    },
    //编辑选项
    editOption(row) {
      this.type = 'edit'
      this.id = row.id
      this.getOptionDetail(row.id)
      this.dialogTableVisible = true
    },
    getOptionDetail(id) {
      getOptionDetail(id).then(res => {
        if (res.success) {
          let option = res.model || {}

          this.optionForm = {
            field: option.field,
            label: option.label,
            value: option.value,
            sort: option.sort,
            bool_radio: option.bool_radio,
            uq_code: option.uq_code
          }
        }

      })
    },
    banchDelete(ids) {
      let that = this
      // eslint-disable-next-line
      deleteOption(ids).then(res => {
        that.showToast({
          h: that
        })
        let data = Object.assign(that.optionSet, that.params)
        that.getOptionList(data)
      })
    },

    newOption() {
      let that = this
      let data = that.optionForm
      if (that.type === 'edit') {
        data.id = that.id
      }
      data.sort = data.sort || 0
      // eslint-disable-next-line
      addOrEditOption(data).then(res => {
        that.showToast({
          h: that
        })
        let data = Object.assign(that.optionSet, that.params)
        that.getOptionList(data)
        that.dialogTableVisible = false
      })
    },
    cancel() {
      this.dialogTableVisible = false
    }
  }
}
</script>
<style scoped>
.form {
    margin-top: 10px;
}

.header {
    background: #fff;
    /*padding: 0 30px 0 30px;*/
    /*border-bottom: 1px solid #F2F2F2;*/
}

.tableCon {
    background: #fff;
    padding: 22px 30px 0 30px;
}
</style>
<style>
div.el-dialog {
    width: 40%;
}

div.optionForm {
    width: 80%;
    margin: 0 auto;
}

.optionSelect {
    width: 100%;
}

div.el-dialog__header {
    text-align: left;
}
</style>
